// extracted by mini-css-extract-plugin
module.exports = {"title":"withdrawalRequest_title__3WsxP","formContainer":"withdrawalRequest_formContainer__3M2ml","inerContainer":"withdrawalRequest_inerContainer__1lR_q"};